import GetStartedCard from "./GetStartedCard"

export default function CtaSection({
  title = "Get Started in Minutes",
  desc = "Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices",
  primaryText = "Explore Solutions",
  secondaryText = "Contact us",
  primaryHref = "/services",
  secondaryHref = "/contact",
}) {
  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"

  return (
    <section className="bg-white py-10 sm:py-12 lg:py-16">
      <div className={containerClass}>
        <GetStartedCard
          title={title}
          desc={desc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          primaryHref={primaryHref}
          secondaryHref={secondaryHref}
        />
      </div>
    </section>
  )
}
